import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, TabButton } from "../../../components";
import { useLocation, withRouter } from "react-router-dom";
import { getAllMenus } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { setMenuList } from "../../Menus/redux/actions";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const lan = getLanguage();

const Index = (props) => {
  const [categoryList, setCategoryList] = useState([]);
  const menusList = useSelector((state) => state.menuReducer.menuList);
  const [menu, setMenu] = useState("home");

  const dispatch = useDispatch();
  const location = useLocation();

  const goToPage = (key) => {
    console.log("key", key);
    props.setMenuName(key);
    // eslint-disable-next-line default-case
    switch (key) {
      case "home":
        props.history.push("/");
        break;
      case "hotnews":
        props.history.push("/hotnews");
        break;
      case "gov-jobs":
        props.history.push("/government-jobs");
        break;
      case "gov-gazette":
        props.history.push("/government-gazette");
        break;
      case "contact":
        props.history.push("/contact-us");
        break;
      default:
        props.history.push("/" + key);
    }
  };

  useEffect(() => {
    let param = location.pathname.split("/");

    let newCategory = param[1];
    if (newCategory !== menu) {
      setMenu(newCategory);
      props.setMenuName(newCategory);
    }
  }, [location.pathname]);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getAllMenus();
      console.log("menulist:::::", { response });
      if (response?.data) {
        setCategoryList(response.data);
        dispatch(setMenuList(response.data));
      }
    };
    if (menusList?.length === 0) {
      fetchCategories();
    }
  }, []);

  // slider
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = (menusList?.langth || 0) + 2; // +2 for "Home" and "Contact us"
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  const settings = {
    variableWidth: true,
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2, //number of items sliding at a time
    initialSlide: 0,
    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
    afterChange: (index) => setCurrentSlide(index),
    nextArrow: (
      <div className="rvow__next">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronRight />,
            buttonType: isLastSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__next",
          }}
        />
      </div>
    ),

    prevArrow: (
      <div className="rvow__prev">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronLeft />,
            buttonType: isFirstSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__prev",
          }}
        />
      </div>
    ),
  };

  // const settings = {
  //   variableWidth: true,
  //   className: "slider variable-width",
  //   dots: false,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
  //   afterChange: (index) => setCurrentSlide(index),
  //   nextArrow: (
  //     <div className={"rvow__next slick-arrow slick-next"}>
  //       <Button
  //         data={{
  //           buttonIcon: true,
  //           btnIcon: <FiChevronRight />,
  //           buttonType: "icon",
  //           buttonSize: "md",
  //           style: "rvow__next",
  //         }}
  //       />
  //     </div>
  //   ),
  //   prevArrow: (
  //     <div className={`rvow__prev slick-arrow slick-prev`}>
  //       <Button
  //         data={{
  //           buttonIcon: true,
  //           btnIcon: <FiChevronLeft />,
  //           buttonType: currentSlide === 0 ? "disabled" : "icon", // <== CORE LOGIC
  //           buttonSize: "md",
  //           style: "rvow__prev",
  //         }}
  //       />
  //     </div>
  //   ),
  // };
  return (
    <>
      <div className={`menu-wrapper`}>
        <div className={"menu-wrapper__slider"}>
          {/* <Slider
            // {...settings}
            className={"rvow__slider d-flex flex-row justify-content-center"}
          > */}
          <div
            className={"rvow__slider d-flex flex-row justify-content-center"}
          >
            <TabButton
              data={{
                lan: lan,
                tabName: lan === "si" ? "මුල් පිටුව" : "Home",
                isActive: menu === "home" || props.location.pathname === "/",
                type: "english",
                size: "sm",
              }}
              // onClick={() => {
              //   if (home) {
              //     //  props.history.push("/");
              //     setHome("");
              //   } else {
              //     setHome("home");
              //   }
              // }}
              onClick={() => {
                goToPage("home");
                setMenu("home");
              }}
            />
            <TabButton
              data={{
                lan: lan,
                tabName: lan === "si" ? "රැකියා" : "Government jobs",
                type: "english",
                size: "sm",
                isActive:
                  menu === "gov-jobs" ||
                  props.location.pathname?.includes("jobs"),
              }}
              onClick={() => {
                // props.history.push("/gov-jobs");
                goToPage("gov-jobs");
                setMenu("gov-jobs");
              }}
            />
            <TabButton
              data={{
                lan: lan,
                tabName: lan === "si" ? "ගැසට්" : "Gazette",
                type: "english",
                size: "sm",
                isActive:
                  menu === "gov-gazette" ||
                  props.location.pathname?.includes("government-gazette"),
              }}
              onClick={() => {
                // props.history.push("/gov-jobs");
                goToPage("gov-gazette");
                setMenu("gov-gazette");
              }}
            />
            {menusList?.map((item, index) => (
              <TabButton
                data={{
                  lan: lan,
                  tabName: item.menu_name[lan],
                  isActive:
                    menu === item.category ||
                    props.location.pathname === "/" + item.category,

                  type: lan === "en" ? "english" : "sinhala",
                  size: "sm",
                }}
                onClick={() => {
                  // goToPage(item.category);
                  props.history.push("/" + item.category);
                  props.setMenuName(item.category);
                  setMenu(item.category);
                }}
              />
            ))}
            <TabButton
              data={{
                lan: lan,
                tabName: lan === "si" ? "අප අමතන්න" : "Contact us",
                type: "english",
                size: "sm",
                isActive:
                  menu === "contact" ||
                  props.location.pathname?.includes("contact-us"),
              }}
              onClick={() => {
                // props.history.push("/contact-us");
                goToPage("contact");
                setMenu("contact");
                // if (contact) {
                //   setContact("");
                // } else {
                //   setContact("contact");
                // }
              }}
            />
            {/* </Slider> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Index);
